import { render, staticRenderFns } from "./unmenu.vue?vue&type=template&id=aa890de4&scoped=true&"
import script from "./unmenu.vue?vue&type=script&lang=js&"
export * from "./unmenu.vue?vue&type=script&lang=js&"
import style0 from "./unmenu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./unmenu.vue?vue&type=style&index=1&id=aa890de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa890de4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
